import React from 'react';
import { Collapse } from 'antd';
import { I18n } from '@aws-amplify/core';
import { CollapseContainer } from './styles';

interface FilterCollapseProps {
	isCollapseOpen?: boolean;
	children: React.ReactNode;
}

const { Panel } = Collapse;

export function FilterCollapse({ isCollapseOpen = true, children }: Readonly<FilterCollapseProps>) {
	return (
		<CollapseContainer defaultActiveKey={isCollapseOpen ? '1' : '0'}>
			<Panel key="1" header={I18n.get('Filter')}>
				{children}
			</Panel>
		</CollapseContainer>
	);
}
